import styled from 'styled-components';

export const AttachmentsSendContainer = styled.div`
  padding: 16px;
  margin: 16px 0;

  .ant-btn {
    margin-left: auto;
    margin-top: 8px;
  }
`;

export const UploaderContent = styled.div`
  .anticon {
    margin-bottom: 8px;
    font-size: 2.5rem;
    color: ${({ theme }) => theme.colors.primary};
  }
`;
